import CustomFileInput from "../../../common/CustomFileInput";
import { useEffect, useRef, useState } from "react";
import { useFormContext } from "react-hook-form";
import FloatingInput from "@/common/input/floatingInput";
import * as T1 from "./typeOne.styles";
import Accordion2 from "@/common/accordion/accordion2";

const TypeFour = ({
  userInfoList,
  inputData,
  setInputData,
  handleInputData,
  onClickHandleModal,
}) => {
  const {
    register,
    formState: { errors },
    setValue,
    getValues,
    reset,
    trigger,
  } = useFormContext();

  const [activeTab, setActiveTab] = useState([]);
  const fileRef = useRef();

  const accordionData = [
    {
      title: "문의 내용",
      content: (
        <>
          <div className="form-group mb-0">
            <textarea
              placeholder="문의내용"
              className="mt-3"
              name="memo"
              value={inputData?.memo || ""}
              {...register("memo", {
                value: inputData?.memo,
                onChange: (e) => handleInputData(e, "memo"),
              })}
            />
            <div className="d-flex flex-column">
              <div className="d-flex align-items-center justify-content-between mb-2">
                <h6 className="">파일 업로드</h6>
              </div>
              <div ref={fileRef}>
                <CustomFileInput
                  handleFiles={(files) => {
                    setInputData({ ...inputData, file: files[0] });
                  }}
                  reset={(files) => reset({ ...getValues(), file: files[0] })}
                  error={errors?.file}
                  name={"files"}
                  max={1}
                />
              </div>
              {errors?.file && (
                <span className="mt-1 text-danger">{errors?.file.message}</span>
              )}
            </div>
            <div className="mt-3 d-flex flex-column">
              {errors?.editYn && (
                <span className="mt-1 text-danger">
                  {errors?.editYn.message}
                </span>
              )}
            </div>
          </div>
        </>
      ),
    },
    {
      title: "주문자 정보",
      content: (
        <>
          <FloatingInput
            placeholder="업체명"
            name="company"
            register={(name) => {
              return {
                ...register(name, {
                  value: inputData?.[name],
                  onChange: (e) => handleInputData(e, name),
                }),
              };
            }}
            value={inputData?.company || ""}
            error={errors?.company}
          />
          <FloatingInput
            placeholder="담당자"
            name="name"
            register={(name) => {
              return {
                ...register(name, {
                  value: inputData?.[name],
                  onChange: (e) => handleInputData(e, name),
                }),
              };
            }}
            value={inputData?.name || ""}
            error={errors?.name}
          />
          <FloatingInput
            placeholder="연락처"
            name="phone"
            register={(name) => {
              return {
                ...register(name, {
                  value: inputData?.[name],
                  onChange: (e) => handleInputData(e, name),
                }),
              };
            }}
            value={inputData?.phone || ""}
            error={errors?.phone}
          />
          <FloatingInput
            placeholder="이메일"
            name="email"
            register={(name) => {
              return {
                ...register(name, {
                  value: inputData?.[name],
                  onChange: (e) => handleInputData(e, name),
                }),
              };
            }}
            value={inputData?.email || ""}
            error={errors?.email}
          />
          <div className="d-fles flex-column mb-3">
            <div className="custome-checkbox d-flex align-items-start">
              <input
                type="checkbox"
                id="checkBox0"
                className="form-check-input"
                style={{ paddingTop: "2px" }}
                checked={inputData?.check || ""}
                {...register("check", {
                  onChange: (e) => handleInputData(e, "check"),
                })}
              />
              <label className="form-check-label" htmlFor="checkBox0"></label>
              <label htmlFor="checkBox0">
                (동의 필수) 제출하신 정보로 신청자께 칼렛스토어 소식을
                보내드립니다.
              </label>
            </div>
            {errors?.check && (
              <div className="text-danger mt-1">{errors.check?.message}</div>
            )}
          </div>
        </>
      ),
    },
    {
      title: "배송지 정보",
      content: (
        <>
          <div className="form-group mb-0">
            <FloatingInput
              placeholder="주소"
              name="doro_addr"
              register={(name) => {
                return {
                  ...register(name, {
                    value: inputData?.[name],
                    onChange: (e) => handleInputData(e, name),
                  }),
                };
              }}
              value={inputData?.doro_addr || inputData?.base_addr || ""}
              readOnly
              onClick={onClickHandleModal}
              error={errors?.doro_addr}
            />
            <FloatingInput
              placeholder="상세 주소"
              name="detail_addr"
              value={inputData?.detail_addr || ""}
              register={(name) => {
                return {
                  ...register(name, {
                    value: inputData?.[name],
                    onChange: (e) => handleInputData(e, name),
                  }),
                };
              }}
              error={errors?.detail_addr}
            />
          </div>
        </>
      ),
    },
  ];

  // inputData가 변경될 때마다 form 값 동기화
  useEffect(() => {
    // 주소 값이 있을 때만 form에 설정
    if (inputData?.doro_addr || inputData?.base_addr) {
      setValue("doro_addr", inputData?.doro_addr || inputData?.base_addr);
    }
    if (inputData?.detail_addr) {
      setValue("detail_addr", inputData?.detail_addr);
    }
  }, [inputData, setValue]);

  useEffect(() => {
    if (userInfoList) {
      const updatedData = {
        base_addr: userInfoList.Address?.data?.[0]?.base_addr || "",
        detail_addr: userInfoList.Address?.data?.[0]?.detail_addr || "",
        company:
          userInfoList.Company?.ReturnCode === "9999" ? "" : inputData.company,
        email: userInfoList.Member?.email || "",
        name: userInfoList.Member?.name || "",
        phone: userInfoList.Member?.phone || "",
      };

      setInputData((prev) => ({
        ...prev,
        ...updatedData,
      }));

      // form 값 업데이트 및 에러 초기화
      reset(updatedData);
    }
  }, [userInfoList, reset]);

  //에러 관련해서 scroll
  useEffect(() => {
    if (Object.keys(errors).length > 0) {
      const tempArr = new Array(accordionData.length).fill(true);
      setActiveTab(tempArr);

      if (Object.keys(errors).length === 1 && errors.file) {
        stickyBodyRef.current.scrollTo({
          behavior: "instant",
          left: 0,
          top: fileRef.current.offsetTop - 130,
        });
      }
    }
  }, [errors]);

  return (
    <>
      <T1.TypeOneSection>
        {accordionData?.length > 0 &&
          accordionData.map((el, i) => (
            <Accordion2 data={el} open={activeTab[i]} key={i} />
          ))}
      </T1.TypeOneSection>
    </>
  );
};
export default TypeFour;
